import React from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useHistory } from 'react-router-dom';
import logo from '../../../images/logoV2.png';
import Auth from '../../../utils/Auth';

export default () => {
  const history = useHistory();

  const logout = (event) => {
    event.preventDefault();
    Auth.logout();
    history.push('/login');
  };

  return (
    <Navbar collapseOnSelect>
      <Navbar.Header>
        <Navbar.Brand>
          <img
            src={logo}
            className="admin-logo"
            alt="Korecki Real Estate Services"
          />
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav pullRight>
          <LinkContainer to="/admin/dashboard">
            <NavItem eventKey={1}>Dashboard</NavItem>
          </LinkContainer>
          <LinkContainer to="/admin/document">
            <NavItem eventKey={1}>Documents</NavItem>
          </LinkContainer>
          <NavItem eventKey={2} onClick={logout}>
            Log Out
          </NavItem>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
